import { createSlice } from "@reduxjs/toolkit";

const tableDataSlice = createSlice({
  name: "tableData",
  initialState: [],
  reducers: {
    addItemToTableData: (state, action) => {
      const item = { ...action.payload };
      if (item._replaceIndex !== undefined && item._replaceIndex !== null) {
        const replaceIndex = item._replaceIndex;
        delete item._replaceIndex;
        state[replaceIndex] = item;
      } else {
        state.push(item);
      }
    },

    replaceItemInTableData: (state, action) => {
      const { index, item } = action.payload;
      state[index] = item;
    },
    updateQtyAndTotal: (state, action) => {
      const { index, qty, taxAmt, total } = action.payload;
      state[index].qty = qty;
      state[index].taxAmt = taxAmt;
      state[index].total = total;
    },
    updateBatch: (state, action) => {
      const { index, batch, edite } = action.payload;
      if (edite) {
        state[index].batch = batch.split(", ");
      } else {
        state[index].batch = [...state[index].batch, batch];
      }
    },
    selectedRowOrCurrentRow: (state, action) => {
      // Iterate over all items in the state.
      const { name } = action.payload;

      state.forEach((item) => {
        // Set selectedRow to true for the current index, false for others
        item.selectedRow = item.ItemNameTextField === name;
      });
    },
    updateRateAndTotal: (state, action) => {
      const { index, Rate1, qty, taxAmt } = action.payload;
      state[index].Rate1 = Rate1;
      state[index].total = Rate1 * qty + taxAmt;
      state[index].taxAmt = taxAmt;
    },
    updateRateAndTotalTaxUtilityEnabled: (state, action) => {
      const { index, Rate1, qty, taxAmt } = action.payload;
      state[index].Rate1 = Rate1;
      state[index].total = Rate1 * qty;
      state[index].taxAmt = taxAmt;
    },
    deleteItemFromTableData: (state, action) => {
      const index = state.findIndex(
        (item) => item.ItemNo === action.payload.ItemNo,
      );
      if (index !== -1) {
        state.splice(index, 1);
      }
    },
    clearTableData: (state, action) => {
      return [];
    },
    // New reducer to replace the array with new data
    replaceTableData: (state, action) => {
      return action.payload; // Set the state to the new data
    },
  },
});

export const {
  addItemToTableData,
  updateRateAndTotal,
  updateQtyAndTotal,
  deleteItemFromTableData,
  clearTableData,
  replaceTableData,
  updateRateAndTotalTaxUtilityEnabled,
  updateBatch,
  selectedRowOrCurrentRow,
  replaceItemInTableData,
} = tableDataSlice.actions;
export default tableDataSlice.reducer;
